/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PlanTier {
    PRO = 'PRO',
    TEAM = 'TEAM'
}

export function PlanTierFromJSON(json: any): PlanTier {
    return PlanTierFromJSONTyped(json, false);
}

export function PlanTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanTier {
    return json as PlanTier;
}

export function PlanTierToJSON(value?: PlanTier | null): any {
    return value as any;
}

